module.exports = __webpack_public_path__ + "img/vn6-vietnams-environmental-policies.25f550d8.jpg";